import { nl, enGB } from 'date-fns/locale';

const locales = {
  nl,
  en: enGB,
};
export default locales;
